import { useContext } from "react";
import { MemberEligibilityContext } from "../context/MemberEligibilityContext";

export const useIsLoggedInUser = () => {
  const { isViewingDataholder } = useContext(MemberEligibilityContext);
  const isEmulating = !!sessionStorage.getItem("isEmulation");

  return {
    isLoggedInUser: !isViewingDataholder && !isEmulating,
    isEmulating: isEmulating,
    isViewingDataholder: isViewingDataholder,
  };
};
